import React from "react";
import { FiDownload } from "react-icons/fi";
import { Play } from "lucide-react";
import { useDownload } from "../DownloadWindow/DownloadContext";
import { trackDownloadClick } from "../../lib/analytics";
import {
  MAC_APP_STORE_URL,
  PLAY_STORE_URL,
  WINDOWS_INSTALLER_URL,
} from "../../hooks/useSmartDownload";
import { SCROLL_OFFSET, ARTICLE_COLUMN, BODY, SOFT_PANEL } from "./sections";

// Analytics location forwarded with every download_click from this panel.
const CTA_LOCATION = "voice_typing_vs_built_in_dictation_cta";

const PRIMARY_BUTTON =
  "inline-flex cursor-pointer items-center gap-[8px] rounded-[12px] bg-gradient-to-r from-[#3AB1F6] to-[#407BFF] px-[18px] py-[11px] font-inter text-[14px] font-semibold leading-[20px] text-white shadow-[0_4px_18px_rgba(58,177,246,0.35)] transition-all duration-300 hover:-translate-y-0.5 hover:from-[#33A2E5] hover:to-[#386FE8] hover:shadow-xl";

const SECONDARY_BUTTON =
  "inline-flex cursor-pointer items-center gap-[8px] rounded-[12px] border-[1.34px] border-[#E6ECF5] bg-white px-[18px] py-[11px] font-inter text-[14px] font-semibold leading-[20px] text-[#0A0D16] transition-all duration-300 hover:-translate-y-0.5 hover:border-[#3AB1F6] hover:text-[#3AB1F6]";

const TryItSection = () => {
  const downloadCtx = useDownload();

  const handleWindowsDownload = (e) => {
    trackDownloadClick({
      platform: "windows",
      file_name: "ZeroTypingAI.msi",
      location: CTA_LOCATION,
    });
    // Inside the provider, stream via DownloadContext (progress + the
    // file_download completion event), exactly like the footer button.
    // Otherwise let the href download natively.
    if (downloadCtx?.startDownload) {
      e.preventDefault();
      downloadCtx.startDownload({ platform: "windows", location: CTA_LOCATION });
    }
  };

  return (
    <section
      id="try-it"
      style={{ scrollMarginTop: `${SCROLL_OFFSET}px` }}
      className={ARTICLE_COLUMN}
    >
      <div className={`${SOFT_PANEL} p-[24px] sm:p-[32px]`}>
        <h2 className="font-jakarta text-[24px] font-bold leading-[1.25] tracking-[-0.5px] text-[#0A0D16] sm:text-[28px]">
          Try It Instead of Reading About It
        </h2>

        <p className={`mt-[12.88px] ${BODY}`}>
          Zero Typing is free to start: 15 minutes of transcription per week,
          Personal Dictionary included, no credit card required.
        </p>

        {/* Platform buttons - href kept so right-click / copy-link still work */}
        <div className="mt-[25.76px] flex flex-wrap items-center gap-[12px]">
          <a
            href={MAC_APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              trackDownloadClick({ platform: "mac", location: CTA_LOCATION })
            }
            className={PRIMARY_BUTTON}
          >
            <FiDownload className="h-[15px] w-[15px] shrink-0" />
            <span>Download for Mac</span>
          </a>

          <a
            href={WINDOWS_INSTALLER_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleWindowsDownload}
            className={SECONDARY_BUTTON}
          >
            <FiDownload className="h-[15px] w-[15px] shrink-0" />
            <span>Download for Windows</span>
          </a>

          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              trackDownloadClick({ platform: "android", location: CTA_LOCATION })
            }
            className={SECONDARY_BUTTON}
          >
            <Play className="h-[15px] w-[15px] shrink-0" strokeWidth={2.2} />
            <span>Get it on Google Play</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default TryItSection;
